import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import CampaignDetailPage from "./CampaignDetailPage";
import { useRecruitment } from "../../../context/RecruitmentContext";

const ApplyPage = () => {
  const { campaignId } = useParams();
  const { openCandidateModal, isCandidateRegistered } = useRecruitment();

  useEffect(() => {
    if (!isCandidateRegistered) {
      openCandidateModal(campaignId, { showCvUpload: true });
    }
  }, [campaignId, isCandidateRegistered, openCandidateModal]);

  return <CampaignDetailPage />;
};

export default ApplyPage;
